"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
const component_1 = require("@front/components/progress-bar/component");
component_1.ProgressBarComponent;
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label htmlFor="${x => x.name}" class="">${x => x.label.t()}</label>`)}
    <div class="file-upload-wrapper">
        <input 
            type="file" 
            @change="${(x, c) => x.handleFileChange(c.event)}" 
            name="${x => x.name}" 
            class="form-control file-input" 
            ?required="${x => x.isRequired}"
            accept="${x => x.accept || ''}"
            ?multiple="${x => x.multiple === 'true'}"
            style="display: none;"
            id="${x => x.name + '_file_input'}"
        />
        
        <div class="file-upload-display">
            <button 
                type="button" 
                class="btn btn-outline-secondary file-upload-btn ${x => x.isDragOver ? 'drag-over' : ''} ${x => x.multiple === 'true' ? 'multi-file' : ''}"
                @click="${x => x.getElement().click()}"
                @drop="${(x, c) => x.handleDrop(c.event)}"
                @dragover="${(x, c) => x.handleDragOver(c.event)}"
                @dragenter="${(x, c) => x.handleDragEnter(c.event)}"
                @dragleave="${(x, c) => x.handleDragLeave(c.event)}"
                ?disabled="${x => x.isLoading}"
            >
                ${(0, fast_element_1.when)(x => x.isLoading, T.html `
                    ${'file.upload.loading'.t()}
                `)}
                ${(0, fast_element_1.when)(x => !x.isLoading && !x.fileName && !x.isDragOver, T.html `
                    <i class="simple-icon-cloud-upload"></i> ${x => x.placeholder ? x.placeholder.t() : (x.multiple === 'true' ? 'file.upload.choose_multiple'.t() : 'file.upload.choose'.t())}
                `)}
                ${(0, fast_element_1.when)(x => !x.isLoading && !x.fileName && x.isDragOver, T.html `
                    <i class="simple-icon-cloud-upload"></i> ${'file.upload.drop'.t()}
                `)}
                ${(0, fast_element_1.when)(x => !x.isLoading && x.fileName, T.html `
                    <i class="simple-icon-doc"></i> ${x => x.multiple === 'true' ? 'file.upload.change_multiple'.t() : 'file.upload.change'.t()}
                `)}
            </button>
            
            ${(0, fast_element_1.when)(x => x.fileName && x.multiple !== 'true', T.html `
                <div class="file-info">
                    <div class="file-details">
                        <span class="file-name">${x => x.fileName}</span>
                        <span class="file-size text-muted">(${x => x.fileSize})</span>
                    </div>
                    <div class="file-actions">
                        ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.value) === null || _a === void 0 ? void 0 : _a.id) && !Array.isArray(x.value); }, T.html `<button 
                            type="button" 
                            class="btn btn-sm btn-outline-primary download-file-btn"                            
                            @click="${(x, c) => x.downloadFile(c.event)}"                            
                            title="${'file.upload.download'.t()}"
                        >
                            <i class="simple-icon-cloud-download"></i>
                        </button>`)}
                        <button 
                            type="button" 
                            class="btn btn-sm btn-outline-danger clear-file-btn"
                            @click="${x => x.clearFile()}"
                            title="${'file.upload.remove'.t()}"
                        >
                            <i class="simple-icon-close"></i>
                        </button>
                    </div>
                </div>
            `)}
            
            ${(0, fast_element_1.when)(x => x.multiple === 'true' && x.fileCount > 0, T.html `
                <div class="multi-file-info">
                    <div class="file-summary">
                        <span class="file-count">${x => x.fileCount} file(s) selected</span>
                        <span class="file-size text-muted">(${x => x.fileSize})</span>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-outline-danger clear-all-btn"
                            @click="${x => x.clearFile()}"
                            title="${'file.upload.remove_all'.t()}"
                        >
                            <i class="simple-icon-close"></i> Clear All
                        </button>
                    </div>
                    <div class="file-list">
                        ${T.repeat(x => Array.isArray(x.value) ? x.value : [], T.html `
                            <div class="file-item">
                                <span class="file-name">${x => x.originalName || x.filename}</span>
                                <span class="file-size text-muted">(${(x, c) => c.parent.formatFileSize(x.size)})</span>
                                <button type="button" class="btn btn-sm btn-outline-danger" @click="${(x, c) => c.parent.removeFile(c.index)}">
                                    <i class="simple-icon-close"></i>
                                </button>
                            </div>
                        `, { positioning: true })}
                    </div>                    
                </div>
            `)}                        
        </div>
    </div>
    <progress-bar :isVisible="${x => x.uploadStarted}" :progress="${x => x.uploadProgress}"></progress-bar>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.file-upload-wrapper {
  position: relative;
}
.file-upload-wrapper .file-upload-display {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.file-upload-wrapper .file-upload-display .file-upload-btn {
  width: 100%;
  padding: 8px 16px;
  border: 2px dashed #dee2e6;
  background: #f8f9fa;
  transition: all 0.3s ease;
}
.file-upload-wrapper .file-upload-display .file-upload-btn:hover:not(:disabled) {
  border-color: #007bff;
  background: #e7f3ff;
}
.file-upload-wrapper .file-upload-display .file-upload-btn.drag-over {
  border-color: #28a745;
  background: #d4edda;
  color: #155724;
}
.file-upload-wrapper .file-upload-display .file-upload-btn.multi-file {
  min-height: 60px;
  padding: 16px;
}
.file-upload-wrapper .file-upload-display .file-upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.file-upload-wrapper .file-upload-display .file-upload-btn i {
  margin-right: 8px;
}
.file-upload-wrapper .file-upload-display .file-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.file-upload-wrapper .file-upload-display .file-info .file-details {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.file-upload-wrapper .file-upload-display .file-info .file-details .file-name {
  font-weight: 500;
  color: #495057;
}
.file-upload-wrapper .file-upload-display .file-info .file-details .file-size {
  font-size: 0.875rem;
}
.file-upload-wrapper .file-upload-display .file-info .file-actions {
  display: flex;
  gap: 8px;
  margin-left: 10px;
}
.file-upload-wrapper .file-upload-display .file-info .file-actions .download-file-btn,
.file-upload-wrapper .file-upload-display .file-info .file-actions .clear-file-btn {
  padding: 4px 8px;
}
.file-upload-wrapper .file-upload-display .file-info .file-actions .download-file-btn i,
.file-upload-wrapper .file-upload-display .file-info .file-actions .clear-file-btn i {
  font-size: 0.875rem;
}
.file-upload-wrapper .file-upload-display .multi-file-info {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #e9ecef;
  border-bottom: 1px solid #dee2e6;
  font-weight: 500;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-summary .file-count {
  color: #495057;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-summary .clear-all-btn {
  padding: 2px 8px;
  font-size: 0.8rem;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list {
  max-height: 300px;
  overflow-y: auto;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item:hover {
  background: #f8f9fa;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item:last-child {
  border-bottom: none;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item .file-name {
  flex: 1;
  font-weight: 500;
  color: #495057;
  margin-right: 10px;
  word-break: break-word;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item .file-size {
  font-size: 0.8rem;
  margin-right: 10px;
  white-space: nowrap;
}
.file-upload-wrapper .file-upload-display .multi-file-info .file-list .file-item button {
  padding: 2px 6px;
  font-size: 0.8rem;
}`;
const shadowOptions = { "mode": "open" };
let FileUploadPart = class FileUploadPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.multiple = 'false';
        this.mode = 'base64';
        this.isLoading = false;
        this.isDragOver = false;
        this.fileCount = 0;
        this.uploadStarted = false;
        this.uploadProgress = 0;
        this.ignored = 'false';
        this.dontEmit = false;
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    valueChanged(oldValue, newValue) {
        // Update display when value changes externally
        if (this.multiple === 'true') {
            const files = newValue;
            this.fileCount = files ? files.length : 0;
            if (files && files.length > 0) {
                this.fileName = `${files.length} file(s) selected`;
                this.fileSize = this.formatTotalSize(files);
            }
            else {
                this.fileName = '';
                this.fileSize = '';
            }
        }
        else {
            const file = newValue;
            if (file) {
                this.fileName = file.originalName || file.filename;
                this.fileSize = this.formatFileSize(file.size);
            }
            else {
                this.fileName = '';
                this.fileSize = '';
            }
        }
    }
    getElement() {
        return this.$('input[type="file"]');
    }
    getDropZone() {
        return this.$('.file-upload-btn');
    }
    async handleFileChange(event) {
        const input = event.target;
        const files = input.files;
        if (!files || files.length === 0) {
            this.value = this.multiple === 'true' ? [] : null;
            this.fileName = '';
            this.fileSize = '';
            this.fileCount = 0;
            this.handleChange({ target: this });
            return;
        }
        if (this.multiple === 'true') {
            await this.processMultipleFiles(Array.from(files));
        }
        else {
            await this.processFile(files[0]);
        }
    }
    async handleDrop(event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
        const files = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
        if (!files || files.length === 0) {
            return;
        }
        const fileArray = Array.from(files);
        // Check if file types are accepted
        if (this.accept) {
            const validFiles = fileArray.filter(file => this.isFileTypeAccepted(file));
            if (validFiles.length !== fileArray.length) {
                console.warn('Some files were not accepted due to type restrictions');
            }
            if (this.multiple === 'true') {
                await this.processMultipleFiles(validFiles);
            }
            else if (validFiles.length > 0) {
                await this.processFile(validFiles[0]);
            }
        }
        else {
            if (this.multiple === 'true') {
                await this.processMultipleFiles(fileArray);
            }
            else {
                await this.processFile(fileArray[0]);
            }
        }
        // Update the input element to reflect the dropped files
        const input = this.getElement();
        const dataTransfer = new DataTransfer();
        if (this.multiple === 'true') {
            fileArray.forEach(file => dataTransfer.items.add(file));
        }
        else if (fileArray.length > 0) {
            dataTransfer.items.add(fileArray[0]);
        }
        input.files = dataTransfer.files;
    }
    handleDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }
    handleDragEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }
    handleDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        // Only set isDragOver to false if we're leaving the drop zone itself
        const target = event.target;
        const relatedTarget = event.relatedTarget;
        const dropZone = this.getDropZone();
        if (!dropZone.contains(relatedTarget)) {
            this.isDragOver = false;
        }
    }
    async processFile(file) {
        this.isLoading = true;
        this.fileName = file.name;
        this.fileSize = this.formatFileSize(file.size);
        try {
            // Convert file to base64 if mode is 'base64', otherwise keep the file object
            const targetFile = this.mode === 'base64' ? await this.fileToBase64(file) : file;
            // Create IFile object
            const fileObject = {
                filename: file.name,
                originalName: file.name,
                mimeType: file.type,
                size: file.size,
                path: targetFile, // base64 / file
            };
            this.value = fileObject;
            // Trigger the form part change event
            this.handleChange({ target: this });
            if (this.onSelectFile) {
                this.onSelectFile({ target: this, data: fileObject });
            }
        }
        catch (error) {
            console.error('Error converting file to base64:', error);
            this.value = null;
            this.fileName = '';
            this.fileSize = '';
        }
        finally {
            this.isLoading = false;
        }
    }
    async processMultipleFiles(files) {
        this.isLoading = true;
        try {
            const fileObjects = [];
            for (const file of files) {
                // Convert file to base64 if mode is 'base64', otherwise keep the file object
                const targetFile = this.mode === 'base64' ? await this.fileToBase64(file) : file;
                // Create IFile object
                const fileObject = {
                    filename: file.name,
                    originalName: file.name,
                    mimeType: file.type,
                    size: file.size,
                    path: targetFile, // base64 / file
                };
                fileObjects.push(fileObject);
            }
            this.value = fileObjects;
            this.fileCount = fileObjects.length;
            this.fileName = `${fileObjects.length} file(s) selected`;
            this.fileSize = this.formatTotalSize(fileObjects);
            // Trigger the form part change event
            this.handleChange({ target: this });
            if (this.onSelectFile) {
                this.onSelectFile({ target: this, data: fileObjects });
            }
        }
        catch (error) {
            console.error('Error converting files to base64:', error);
            this.value = [];
            this.fileCount = 0;
            this.fileName = '';
            this.fileSize = '';
        }
        finally {
            this.isLoading = false;
        }
    }
    isFileTypeAccepted(file) {
        if (!this.accept)
            return true;
        const acceptedTypes = this.accept.split(',').map(type => type.trim());
        return acceptedTypes.some(acceptedType => {
            if (acceptedType.startsWith('.')) {
                // File extension check
                return file.name.toLowerCase().endsWith(acceptedType.toLowerCase());
            }
            else if (acceptedType.includes('/*')) {
                // MIME type wildcard check (e.g., "image/*")
                const mimeCategory = acceptedType.split('/')[0];
                return file.type.startsWith(mimeCategory + '/');
            }
            else {
                // Exact MIME type check
                return file.type === acceptedType;
            }
        });
    }
    fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    // Remove the data URL prefix to get just the base64 string
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                }
                else {
                    reject(new Error('Failed to read file as base64'));
                }
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });
    }
    formatFileSize(bytes) {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    formatTotalSize(files) {
        const totalBytes = files.reduce((total, file) => total + file.size, 0);
        return this.formatFileSize(totalBytes);
    }
    removeFile(index) {
        if (this.multiple === 'true' && Array.isArray(this.value) && index >= 0 && index < this.value.length) {
            const oldValue = this.value;
            this.value = this.value.filter((_, i) => i !== index);
            this.fileCount = this.value.length;
            this.fileName = this.value.length > 0 ? `${this.value.length} file(s) selected` : '';
            this.fileSize = this.value.length > 0 ? this.formatTotalSize(this.value) : '';
            // Manually call valueChanged to ensure UI updates
            this.valueChanged(oldValue, this.value);
            this.handleChange({ target: this });
            // Update the input element
            const input = this.getElement();
            input.value = '';
            this.$emit('file-part:clear', { index: index });
        }
    }
    clearFile() {
        console.log('🗑️ FILE REMOVE DEBUG: clearFile() called on component:', this.name);
        console.log('🗑️ FILE REMOVE DEBUG: Current value before clear:', this.value);
        const input = this.getElement();
        input.value = '';
        // Clear all file-related data and force reactivity
        const oldValue = this.value;
        this.value = this.multiple === 'true' ? [] : null;
        this.fileName = '';
        this.fileSize = '';
        this.fileCount = 0;
        console.log('🗑️ FILE REMOVE DEBUG: Value after clear:', this.value);
        // Manually call valueChanged to ensure UI updates
        this.valueChanged(oldValue, this.value);
        // Create a proper mock event that matches what handlePartChange expects
        const mockEvent = {
            target: {
                name: this.name || 'file-upload',
                value: this.value
            }
        };
        console.log('🗑️ FILE REMOVE DEBUG: About to call handleChange with:', mockEvent);
        this.handleChange(mockEvent);
        console.log('🗑️ FILE REMOVE DEBUG: About to emit file-part:clear event');
        this.$emit('file-part:clear', { index: 0 });
        console.log('🗑️ FILE REMOVE DEBUG: clearFile() completed');
    }
    downloadFile(event) {
        event.preventDefault();
        if (!this.value)
            return;
        try {
            // Only support download for single files, not multiple
            if (this.multiple === 'true' || Array.isArray(this.value)) {
                console.warn('Download not supported for multiple files');
                return;
            }
            const file = this.value;
            const downloadUrl = `/uploads/${file.filename}`;
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = file.originalName || file.filename || 'download';
            link.target = '_blank'; // Open in new tab as fallback
            document.body.appendChild(link);
            link.click();
            // Cleanup
            document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error downloading file:', error);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        // If value is already set (like when editing), initialize the display
        if (this.value) {
            if (this.multiple === 'true' && Array.isArray(this.value)) {
                this.fileCount = this.value.length;
                this.fileName = `${this.value.length} file(s) selected`;
                this.fileSize = this.formatTotalSize(this.value);
            }
            else if (this.multiple !== 'true' && !Array.isArray(this.value)) {
                const file = this.value;
                this.fileName = file.originalName || file.filename;
                this.fileSize = this.formatFileSize(file.size);
            }
        }
    }
    reset() {
        this.clearFile();
    }
};
exports.FileUploadPart = FileUploadPart;
FileUploadPart.PART_TYPE = 'file-upload';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], FileUploadPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "accept", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "multiple", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "mode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileUploadPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileUploadPart.prototype, "fileName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], FileUploadPart.prototype, "fileSize", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileUploadPart.prototype, "isLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileUploadPart.prototype, "isDragOver", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], FileUploadPart.prototype, "fileCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], FileUploadPart.prototype, "uploadStarted", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], FileUploadPart.prototype, "uploadProgress", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FileUploadPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FileUploadPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], FileUploadPart.prototype, "onSelectFile", void 0);
exports.FileUploadPart = FileUploadPart = __decorate([
    (0, client_1.RWSView)('part-file-upload', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], FileUploadPart);
FileUploadPart.defineComponent();
